/**
 * Logs cart AJAX and cart* CustomEvents for debugging (no cart behavior changes).
 * Prefix: [cart-debug]
 *
 * Disable: localStorage.setItem('CART_UPDATE_DEBUG','0'); location.reload()
 */
(function () {
  if (window.__cartUpdateDebugInstalled) return;
  window.__cartUpdateDebugInstalled = true;

  function enabled() {
    try {
      return window.localStorage.getItem('CART_UPDATE_DEBUG') !== '0';
    } catch (e) {
      return true;
    }
  }

  function log() {
    if (!enabled()) return;
    var a = Array.prototype.slice.call(arguments);
    a.unshift('[cart-debug]');
    console.log.apply(console, a);
  }

  /* CustomEvent / Event — any type that includes "cart" (case-insensitive) */
  var origDispatch = EventTarget.prototype.dispatchEvent;
  EventTarget.prototype.dispatchEvent = function (event) {
    try {
      if (event && typeof event.type === 'string' && /cart/i.test(event.type)) {
        log('dispatchEvent', event.type, {
          detail: event.detail,
          target: this,
          bubbles: event.bubbles,
          cancelable: event.cancelable
        });
      }
    } catch (e) {}
    return origDispatch.apply(this, arguments);
  };

  /* document / window explicit listeners — known names from this theme + common Dawn-style */
  var names = [
    'cart:updated',
    'cart:update',
    'cart:changed',
    'cart:change',
    'cart:refresh',
    'cart:reload',
    'cart-drawer:open',
    'cart-drawer:close',
    'cart:cleared',
    'cart:clear',
    'line-item:change',
    'line-item:remove',
    'quantity-updated'
  ];
  var root = document.documentElement;
  names.forEach(function (name) {
    try {
      window.addEventListener(
        name,
        function (ev) {
          log('heard on window:', name, ev.detail !== undefined ? { detail: ev.detail } : '');
        },
        true
      );
      document.addEventListener(
        name,
        function (ev) {
          log('heard on document:', name, ev.detail !== undefined ? { detail: ev.detail } : '');
        },
        true
      );
    } catch (e) {}
  });

  /* fetch */
  if (typeof window.fetch === 'function') {
    var nf = window.fetch.bind(window);
    window.fetch = function () {
      var args = arguments;
      var req = args[0];
      var url = typeof req === 'string' ? req : req && req.url;
      var method = (typeof req !== 'string' && req && req.method) || 'GET';

      return nf.apply(window, args).then(function (res) {
        try {
          if (url && typeof url === 'string' && url.indexOf('/cart') !== -1) {
            log('fetch response', method, url.split('?')[0], 'status=', res.status, 'ok=', res.ok);
          }
        } catch (e) {}
        return res;
      });
    };
  }

  /* XMLHttpRequest */
  if (typeof XMLHttpRequest !== 'undefined') {
    var XO = XMLHttpRequest.prototype.open;
    var XS = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartDebugUrl = typeof url === 'string' ? url : '';
      this.__cartDebugMethod = method || 'GET';
      return XO.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;
      var u = xhr.__cartDebugUrl || '';

      function done() {
        if (xhr.readyState === 4 && u.indexOf('/cart') !== -1) {
          log('xhr complete', xhr.__cartDebugMethod || 'GET', u.split('?')[0], 'status=', xhr.status);
        }
      }

      xhr.addEventListener('load', done);
      xhr.addEventListener('error', done);
      return XS.apply(this, arguments);
    };
  }

  log('installed — watch for dispatchEvent / fetch / xhr lines above when you add, change, or remove cart lines');
})();
